var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { List } from 'antd';
import ListItem from '../../ListItem';
import UserSelectionContext from '../context';
import { filterSearchGroups } from '../common';
import arrowRightIcon from '../../images/app_ic_arrow_right.png';
import { GroupTag } from '../../Tags';
function SearchGroupList(_a) {
    var searchData = _a.searchData, onclick = _a.onclick, loadMore = _a.loadMore, onGroupClick = _a.onGroupClick, result = _a.result;
    var _b = React.useContext(UserSelectionContext), tabs = _b.tabs, frozenIds = _b.frozenIds;
    var groupsData = filterSearchGroups(searchData.groups, frozenIds, result) || [];
    var getExtraPart = useCallback(function () {
        return (React.createElement("span", { className: "focus-user-selection-dept-arrow" },
            React.createElement("img", { src: arrowRightIcon, alt: "" })));
    }, []);
    return (React.createElement("div", { className: "search-content-wrap" },
        React.createElement(List, { loadMore: loadMore, dataSource: groupsData, renderItem: function (item) {
                var tag = React.createElement(GroupTag, { kind: item.kind, subKind: item.subKind });
                return (React.createElement(ListItem, { tag: tag, data: item, onCheckChange: function () {
                        if (onclick) {
                            onclick(__assign(__assign({}, item), { name: typeof item.name === 'string'
                                    ? item.name
                                    : item.displayName || '' }));
                        }
                    }, onClick: function () {
                        if (tabs.includes('group')) {
                            onGroupClick(__assign(__assign({}, item), { name: typeof item.name === 'string'
                                    ? item.name
                                    : item.displayName || '' }));
                        }
                    }, extra: tabs.includes('group') ? getExtraPart() : null, checkable: tabs.includes('group') ? false : true }));
            } })));
}
export default SearchGroupList;
//# sourceMappingURL=SearchGroupList.js.map